import { render, staticRenderFns } from "./VideoPlayerNew2.vue?vue&type=template&id=12f32380&scoped=true"
import script from "./VideoPlayerNew2.vue?vue&type=script&lang=js"
export * from "./VideoPlayerNew2.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerNew2.vue?vue&type=style&index=0&id=12f32380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f32380",
  null
  
)

export default component.exports